import { render, staticRenderFns } from "./MessagesToApproveList.vue?vue&type=template&id=36344012&"
import script from "./MessagesToApproveList.vue?vue&type=script&lang=js&"
export * from "./MessagesToApproveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports